import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../../config';
import Pagination from '../../Pagination/Paginations';
import EntriesSelector from '../../Pagination/EntriesSelector';

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
});

const Language = (props) => {

  const { fixNavbar } = props;

  /* ================= STATES ================= */
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    languages: '',
    is_active: 1,
  });
  const [editData, setEditData] = useState({
    language_id: '',
    languages: '',
    is_active: 1,
  });

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = () => {
    axios.get(API_BASE_URL + '/language_list', authHeaders())
    .then(res => {
      setTableData(res.data.data.languages || []);
    })
    .catch(() => toast.error('Failed to load language list'));
  };

  /* ================= ADD ================= */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitting) return;
    if (!formData.languages.trim()) {
      toast.error('Kindly Enter Language!!!');
      return;
    }
    setSubmitting(true);

    axios.post(API_BASE_URL + '/add_language', formData, authHeaders())
    .then(res => {
      toast.success(res.data.message);
      setFormData({ languages: '', is_active: 1 });
      fetchLanguages();
    })
    .catch(err => toast.error(err.response?.data?.message || 'Failed to add language'))
    .finally(() => setSubmitting(false));
  };

  /* ================= UPDATE ================= */
  const handleEditSubmit = (e) => {
    e.preventDefault();

    axios.post(API_BASE_URL + '/update_language', editData, authHeaders())
    .then(res => {
      toast.success(res.data.message);
      setTimeout(() => window.location.reload(), 1500);
    })
    .catch(err => toast.error(err.response?.data?.message || 'Failed to update language'));
  };

  /* ================= SEARCH ================= */
  const filteredData = tableData.filter(item =>
    item.languages?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  /* ================= PAGINATION ================= */
  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filteredData.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  /* ================= DATATABLE STYLES ================= */
  const customStyles = {
    headCells: {
      style: {
        fontWeight: '600',
        fontSize: '13px',
        backgroundColor: '#f8f9fa',
      },
    },
    cells: {
      style: {
        fontSize: '13px',
        paddingTop: '8px',
        paddingBottom: '8px',
      },
    },
    rows: {
      style: {
        minHeight: '42px',
      },
    },
  };

  /* ================= COLUMNS ================= */
  const columns = [
    {
      name: 'Language',
      selector: row => row.languages,
      sortable: true,
    },
    {
      name: 'Status',
      cell: row => (
        <span className={`badge ${Number(row.is_active) === 1 ? 'badge-success' : 'badge-secondary'}`}>
          {Number(row.is_active) === 1 ? 'Active' : 'Inactive'}
        </span>
      ),
    },
    {
      name: 'Created By',
      selector: row => row.created_by_name,
    },
    {
      name: 'Created Date',
      selector: row => row.created_date,
      sortable: true,
    },
    {
      name: 'Action',
      width: '100px',
      cell: row => (
        <button
          className="btn btn-icon btn-sm"
          data-toggle="modal"
          data-target="#editLanguageModal"
          onClick={() => setEditData({
            language_id: row.language_id,
            languages: row.languages,
            is_active: Number(row.is_active),
          })}
        >
          <i className="fa fa-edit" />
        </button>
      ),
    },
  ];

  return (
    <>
      <ToastContainer position="bottom-right" />

      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid">

          {/* ================= ADD LANGUAGE ================= */}
          <div className="card mb-4">
            <div className="card-body">
              <h3 className="card-title d-flex align-items-center mb-3" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                <i className="fa fa-language mr-2" style={{ fontSize: "20px" }} />
                Add Language
              </h3>

              <form onSubmit={handleSubmit}>
                <div className="row align-items-end">
                  <div className="col-md-4">
                    <label>Language Name </label>
                    <input
                      type="text"
                      className="form-control required-input"
                      placeholder="Language"
                      maxLength={100}
                      value={formData.languages}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          languages: e.target.value.replace(/[^A-Za-z ]/g, ''),
                        })
                      }
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Status </label>
                    <select
                      className="form-control"
                      value={formData.is_active}
                      onChange={e =>
                        setFormData({ ...formData, is_active: Number(e.target.value) })
                      }
                    >
                      <option value={1}>Active</option>
                      <option value={0}>Inactive</option>
                    </select>
                  </div>

                  <div className="col-md-2">
                    <button className="btn btn-primary btn-sm" disabled={submitting}>
                      {submitting ? "Saving..." : "Add"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* ================= LANGUAGE LIST ================= */}
          <div className="card">
            <div className="card-header d-flex align-items-center">
              <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                <i className="fa fa-language mr-2" style={{ fontSize: "20px" }} />
                Language List
              </h3>

              <div className="ml-auto">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <EntriesSelector
                    entriesPerPage={entriesPerPage}
                    setEntriesPerPage={setEntriesPerPage}
                    setCurrentPage={setCurrentPage}
                  />
                  <div style={{ marginLeft: '15px' }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search..."
                      style={{ width: '220px' }}
                      value={searchTerm}
                      onChange={e => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <DataTable
                columns={columns}
                data={currentData}
                dense
                striped
                highlightOnHover
                responsive
                persistTableHead
                fixedHeader
                fixedHeaderScrollHeight="400px"
                customStyles={customStyles}
              />

              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>

        </div>
      </div>

      {/* ================= EDIT MODAL ================= */}
      <div className="modal fade" id="editLanguageModal">
        <form onSubmit={handleEditSubmit}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5>Edit Language</h5>
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>

              <div className="modal-body">
                <label>Language Name</label>
                <input
                  type="text"
                  className="form-control required-input mb-3"
                  maxLength={100}
                  value={editData.languages || ''}
                  onChange={e =>
                    setEditData({ ...editData, languages: e.target.value.replace(/[^A-Za-z ]/g, '') })
                  }
                  required
                />

                <label>Status</label>
                <select
                  className="form-control"
                  value={editData.is_active}
                  onChange={e =>
                    setEditData({ ...editData, is_active: Number(e.target.value) })
                  }
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
                <button className="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar,
});

export default connect(mapStateToProps)(Language);
